import { MATERIAL_TO_MATERIAL_MODE } from 'Pods/ThreeDStudio/constants'
import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tripo3d'

/**
 * Inverse of parseTripo3dImageTo3dDefaultData. Builds an openedModel-shaped
 * payload from the current modelSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dImageTo3dDefaultData
 */
export const buildTripo3dImageTo3dDefaultFromState = (state, id) => {
  const { modelSettings } = state
  const {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    isSmartLowPoly,
    selectedUseCase,
  } = modelSettings || {}
  const materialMode = material != null ? MATERIAL_TO_MATERIAL_MODE[material] : undefined
  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TRIPO3D_IMAGE_TO_3D_DEFAULT,
    private: isPrivate,
    useCase: selectedUseCase,
    inputAssets,
    providerRunAttributes: {
      ...(targetPolycount != null && { polycount: targetPolycount }),
      ...(polygonType != null && { topology: polygonType }),
      ...(materialMode != null && { materialMode }),
      ...(isSmartLowPoly && { generateType: 'LowPoly' }),
    },
  }
}
